var map = {
	"./archere.jpg": "8b97",
	"./assassin.jpg": "e757",
	"./assassin_2.jpg": "763a",
	"./close.png": "e999",
	"./mafia_shadow.jpg": "6009",
	"./samurai.jpg": "fdb0",
	"./tap.svg": "ed8e",
	"./tap2.svg": "3dbc",
	"./tap3.svg": "04ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0fe6";